import { render } from "./NissinView.vue?vue&type=template&id=722c65a6"
import script from "./NissinView.vue?vue&type=script&lang=js"
export * from "./NissinView.vue?vue&type=script&lang=js"

import "./NissinView.vue?vue&type=style&index=0&id=722c65a6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__